// VueX
import {
    mapGetters,
} from 'vuex';

// Socios variables
import socios from '@webapp/socios.json';

// Utils
import {
    formatPrice,
} from '@shared/utils/formatter.js';

const tokenCardMixin = {
    name: 'token-card',
    computed: {
        ...mapGetters(['preferredFiatCurrency']),

        ...mapGetters('partners', ['partnerById']),

        ...mapGetters('wallet', [
            'isChzAllowed',
            'ledgersByDecentralizedByBalance',
        ]),

        ...mapGetters('voteTokens', ['voteTokens']),

        partnerId() {
            if (this.$route.params.id) {
                return this.$route.params.id;
            }

            const voteToken = this.voteTokens.find(({ currencyId }) => currencyId === this.token.currency.id);

            return voteToken.partnerId;
        },
        partner() {
            return this.partnerById(this.partnerId);
        },
        totalTokensAmount() {
            return Math.round(Number(this.token.balance) + Number(this.token.lockedBalance));
        },
        fiatAmount() {
            const {
                id,
                shortCode,
            } = this.preferredFiatCurrency;

            return this.getPriceAmount(id, shortCode, shortCode !== 'USD');
        },
        chzAmount() {
            return this.getPriceAmount(socios.chilizCurrencyId, '$CHZ', true);
        },
        alternativeBalance() {
            const prefix = this.fiatAmount === '--' ? '' : '≈';

            return `${prefix}${this.fiatAmount}`;
        },
    },

    methods: {
        getPriceAmount(currencyId, currencySymbol, isSymbolAfter) {
            const total = Number(this.token?.convertedPrices[currencyId]?.balance || 0) + Number(this.token?.convertedPrices[currencyId]?.lockedBalance || 0);

            return total > 0 ? formatPrice(total, currencySymbol, isSymbolAfter) : '--';
        },
        goToPartner() {
            if (this.partner.id) {
                this.$router.push({
                    path: `/partner/${this.partner.id}`,
                });
            }
        },
        goToWalletPartnerDetails() {
            if (this.partner.id) {
                this.$router.push({
                    name: 'wallet-partner-details',
                    params: {
                        id: this.partner.id,
                    },
                });
            }
        },
    },
};

export default tokenCardMixin;